import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const AUTOCOMPLETE_USERS_POPUP_FAIL =
  "COMMON:AUTOCOMPLETE_USERS_POPUP_FAIL";

export interface AutocompleteUsersPopupFailAction extends Action {
  type: typeof AUTOCOMPLETE_USERS_POPUP_FAIL;
  organization: OrganizationKeyName;
}

export const autocompleteUsersPopupFailAction = (
  organization: OrganizationKeyName
): AutocompleteUsersPopupFailAction => ({
  type: AUTOCOMPLETE_USERS_POPUP_FAIL,
  organization,
});
